import PropTypes from 'prop-types'
import React from 'react'
import { Page } from 'SRC/ui'
import { connect } from 'react-redux'
import { ParentCategoriesMenu } from 'SRC/modules/categories/components'
import { fetchCategory, fetchSpecifications } from 'SRC/modules/categories/actions'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { Header } from '../Header'
import { Content } from '../Content'
import { getCurrentAd } from '../../selectors'

export const DetailPage = ({
  ad,
  fetchCategory,
  fetchSpecifications,
  isMobileDevice
}) => {
  React.useEffect(() => {
    if (ad && ad.category && fetchCategory && fetchSpecifications) {
      fetchCategory({ seo: ad.category.seo, layoutStyle: 'no-sidebar' }, false)
      fetchSpecifications(ad.category.id)
    }
  }, [])

  if (!ad) return null

  return (
    <Page>
      {!isMobileDevice ? (
        <div className='ogl-header ogl-header__ad-details'>
          <ParentCategoriesMenu />
        </div>
      ) : null}
      <Header />
      <Content />
    </Page>
  )
}

DetailPage.propTypes = {
  ad: PropTypes.shape(),
  isMobileDevice: PropTypes.string.isRequired,
  fetchCategory: PropTypes.func.isRequired,
  fetchSpecifications: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    ad: getCurrentAd(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

export default connect(mapStateToProps, {
  fetchCategory,
  fetchSpecifications
})(DetailPage)
